/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateUserEvaluationSurveyAnswerDto
 */
export interface CreateUserEvaluationSurveyAnswerDto {

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserEvaluationSurveyAnswerDto
     */
    question: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserEvaluationSurveyAnswerDto
     */
    answer?: JoinEntityDto | null;

    /**
     * Free-text or numeric input (for PLAIN_* question types)
     *
     * @type {string}
     * @memberof CreateUserEvaluationSurveyAnswerDto
     */
    value?: string | null;
}
